import React from "react";

import { Tag, Typography } from "clearsense-ui/components";

import { BLOG_ARTICLES } from "./constants";

const Blogs = () => (
  <div className="blog-section">
    <Typography style="jumbo" className="font-serif text-center">
      Clearsense Insights
    </Typography>
    <Typography style="h3" className="mt-5">
      Latest Articles
    </Typography>
    <div className="grid max-w-lg gap-5 px-16 mx-auto mt-12 overflow-auto lg:grid-cols-4 lg:max-w-none">
      {BLOG_ARTICLES.map(post => (
        <div key={post.title} className="flex flex-col">
          <div className="flex flex-col justify-between p-6 bg-white rounded-lg shadow-lg ">
            <div className="flex items-center justify-start gap-5">
              <p className="font-semibold text-gray-300">{post.date}</p>
              <Tag
                size="large"
                // style="solid"
                label={post.type}
                color={post.labelColor}
              />
            </div>
            <div className="mt-5">
              <div className="block">
                <p className="text-xl font-semibold text-gray-900">
                  {post.title}
                </p>
                <p className="mt-3 text-gray-500 text-small">
                  {post.description}
                </p>
              </div>
              <a
                href={post.href}
                className="block mt-2 text-blue-600 underline"
              >
                Read in {post.readingTime} minutes
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Blogs;
